import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class MasonryServicesGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masonryServicesGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "masonryServicesGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ masonryServicesGallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/masonry-services')
  }


  render() {
    return (
      <>
      <div className="container-fluid text-left">
        <h1>MASONRY GALLERY</h1>
      </div>
      <div>
        {this.state.masonryServicesGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.masonryServicesGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-2 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.masonryServicesGalleryPhoto.fields.file.url} alt="Masonry Services photos" /></label>
                              <label htmlFor={num}><img src={item.fields.masonryServicesGalleryPhoto.fields.file.url} alt="Masonry Services photos" /></label>
                              {/* <p className="text-center">{item.fields.masonryServicesGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Masonry Services</button></Link></p>
      </div>
    </>
    );
  }
}

export default MasonryServicesGallery;
